import React from "react";
import { List, Avatar, Icon, AutoComplete, Input, notification, Spin } from "antd";
import { connect } from "react-redux";
import * as actions from "../../../actions/organizationAction";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import * as orgUseraActions from "../../../actions/organizationUserAction";
import * as orgBillingActions from "../../../actions/organizationBillingAction";
import { bindActionCreators } from "redux";
import { Strings } from "../../../dataProvider/localize";
import { abbrivationStr } from '../../../utils/common';
import ScrollArea from 'react-scrollbar';

class OrganizationSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      viewButton: true,
      activeId: null,
      allLoaded: false
    };
  }

  componentDidMount() {
    this.setState({ viewButton: true });
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (!props.location.pathname.includes("showOrganization")) {

    }
  }

  handelSearchChange = searchValue => {
    this.setState({
      ...this.state,
      searchValue: searchValue,
    });
    if (searchValue.length >= 3) {
      this.props.action.searchExpandOrganisationsList(searchValue, 1, true)
        .then(listLength => {
          if (listLength < 10) {
            this.setState({ viewButton: false })
          } else {
            this.setState({ viewButton: true, allLoaded: false })
          }
        })
        .catch((message) => {
          notification.error({
            message: Strings.error_title,
            description: message ? message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        });
    } else if (searchValue.length === 0) {
      this.props.action.initOrganisations()
        .then((flag) => {
          this.setState({ viewButton: true, allLoaded: false })
        })
        .catch((message) => {
          notification.error({
            message: Strings.error_title,
            description: message ? message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        });
    }
  };

  handelViewAllClick = () => {
    this.props.action.searchExpandOrganisationsList(this.state.searchValue, this.props.pageNumber + 1, false)
      .then((listLength) => {
        this.setState({ viewButton: false }, () => {
          if (listLength < 10) {
            this.setState({ allLoaded: true })
          }
        });
      })
      .catch((message) => {
        notification.error({
          message: Strings.error_title,
          description: message ? message : Strings.generic_error,
          onClick: () => { },
          className: 'ant-error'
        });
      });
  };

  handleOrganizationClick = organId => {
    this.setState({ activeId: organId });
    this.props.orgUseraActions.getOrganizationUsers(organId);
    this.props.orgBillingActions.getOrganizationBillingDetails(organId);
  };

  handleScroll = (value) => {
    if (!this.state.allLoaded && value.topPosition && ((value.containerHeight + value.topPosition) >= value.realHeight)) {
      this.props.action.searchExpandOrganisationsList(this.state.searchValue, this.props.pageNumber + 1, false, true)
        .then((listLength) => {
          if (listLength < 10)
            this.setState({ allLoaded: true })
        })
        .catch((message) => {
          notification.error({
            message: Strings.error_title,
            description: message ? message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        });
    }
  }

  render() {
    // const dataSource = this.props.organizations.filter(organ =>
    //   organ.name.toLowerCase().includes(this.state.searchValue.toLowerCase())
    // );

    const dataSource = this.props.organizations && this.props.organizations.length > 0 ? this.props.organizations : []

    return (
      <div className={this.props.togleSearch ? "col-md-3 mb-4 sf-searchbar" : "col-md-3 mb-4 closed sf-searchbar"}>
        <button onClick={this.props.handleSearchToggle} className="bnt-searchbar open"><Icon type="left" /></button>
        <div className="sf-card">
          <div className="sf-card-head">
            {/* search text box  */}
            <div className="auto-search-txt search-lists">
              <AutoComplete
                className="certain-category-search"
                dropdownClassName="certain-category-search-dropdown"
                dropdownMatchSelectWidth={false}
                dropdownStyle={{ width: 300 }}
                size="large"
                style={{ width: "100%" }}
                onChange={this.handelSearchChange}
                placeholder={Strings.search_placeholder}
                optionLabelProp="value"
              >
                <Input className={this.props.showMiniSpinner ? "list-search-spin" : ""} suffix={
                  !this.props.showMiniSpinner
                    ? <Icon type="search" />
                    : <Spin indicator={<Icon type="loading" spin />} />
                } />
              </AutoComplete>
            </div>
            {/* search text box  */}
          </div>
          <div className={this.state.viewButton && this.props.organizations.length >= 10 ? "sf-search-body" : "sf-search-body add-height"}>
            {
              this.props.showScrollSpinner
                ? <div className="search-list-spin"><Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} /></div>
                : null
            }
            <div className={this.state.viewButton ? "sf-card-body p-0" : "sf-card-body p-0 search-lists-bar"}>
              <ScrollArea speed={0.8} smoothScrolling={true}
                className="sf-scroll" onScroll={(value) => { this.handleScroll(value) }} horizontal={false}>
                <List className="sf-service-list"
                  itemLayout="horizontal"
                  dataSource={dataSource}
                  renderItem={item => (
                    <List.Item
                      className={
                        this.props.location.state !== null
                          ? this.props.location.state === item.id
                            ? "active"
                            : "disable-lists"
                          : ""
                      }
                      onClick={() => this.handleOrganizationClick(item.id)}
                    >
                      <Link
                        to={{
                          pathname: this.props.match.path + "/showOrganization",
                          state: item.id
                        }}
                      >
                        <List.Item.Meta
                          avatar={
                            item.logo ?
                              <Avatar
                                src={
                                  item.logo ? item.logo : "/images/sf-list-img.png"
                                }
                                shape="circle"
                                size="default"
                              /> :
                              <label>{abbrivationStr(item.name)}
                              </label>
                          }
                          title={item.name}
                          description={<div className="itm-amount-date">
                            <span>{item.address}</span>
                          </div>}
                        />
                      </Link>
                    </List.Item>
                  )}
                />
              </ScrollArea>
            </div>
            {
              this.state.viewButton && this.props.organizations.length >= 10
                ? <div className="sf-card-footer d-flex align-items-end justify-content-center">
                  <button className="v-all-org" onClick={this.handelViewAllClick}>{Strings.view_all_org}</button>
                </div>
                : null
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    organizations: state.organization.organizations,
    pageNumber: state.organization.currentPageNumber,
    showMiniSpinner: state.auth.showMiniSpinner,
    showScrollSpinner: state.auth.showScrollSpinner
  };
};

const mapDispatchToprops = dispatch => {
  return {
    action: bindActionCreators(actions, dispatch),
    orgUseraActions: bindActionCreators(orgUseraActions, dispatch),
    orgBillingActions: bindActionCreators(orgBillingActions, dispatch)
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToprops
  )(OrganizationSearch)
);
